import type { GameResult } from '@tunasong/schemas'
import { useRef, useState } from 'react'
import type { GameAction } from './game-action.js'
import { getUserStats } from './game-dynamics.js'

export const useScorer = ({
  userGameResults,
  getScore = ({ bonusTime }) => 1 * Math.max(bonusTime, 1),
  action,
  saveScore,
}: {
  action?: GameAction
  userGameResults: GameResult[]
  getScore?: (params: { bonusTime: number }) => number
  saveScore(score: number): void
}) => {
  const [score, setScore] = useState(0)

  const [bonusTime, setBonusTime] = useState(0)
  const intervalRef = useRef<NodeJS.Timeout | null>(null)
  const scoreMultiplier = action?.scoreMultiplier ?? 1

  const correct = () => {
    setScore(score => Math.floor(score + getScore({ bonusTime }) * scoreMultiplier))
  }
  const fail = () => {
    // Store the score for the user
    if (score <= 0) {
      return
    }
    saveScore(score)
  }

  const resetScore = () => setScore(0)

  const resetBonusTime = (bonusTime: number) => {
    // Reset the time bonus
    setBonusTime(bonusTime)
    if (intervalRef.current) {
      clearTimeout(intervalRef.current)
    }
    intervalRef.current = setInterval(() => {
      setBonusTime(bonusTime => {
        const remaining = Math.max(0, bonusTime - 1)

        return remaining
      })
    }, 1000)
  }

  /** Calculate the streak from the game results. A streak is defined as the number of unique consecutive days with one or more game results. */
  const userStats = getUserStats(userGameResults)

  return { score, correct, fail, bonusTime, resetBonusTime, resetScore, userStats }
}
